<template>
  <div class="home">
    <div class="link-container">
      <div class="link-box" v-for="item in linkList" :key="item.title">
        <div class="link-item" @click="jumpPage(item)">
          <el-image style="width: 80px; height: 80px" :src="item.imgUrl" fit="fill"></el-image>
          <h4 class="link-title">{{ item.title }}</h4>
        </div>
      </div>
    </div>

    <el-row type="flex" justify="space-between">
      <div class="news-box left">
        <el-row type="flex" justify="space-between" align="middle" class="news-title">
          <h4>平台信息</h4>
          <el-link :underline="false" @click="toPage('news')">
            更多
            <i class="el-icon-arrow-right"></i>
          </el-link>
        </el-row>
        <div class="news-content">
          <template v-if="Object.keys(listNews).length">
            <div class="news-item" v-for="item in listNews" :key="item.id">
              <el-row type="flex" justify="space-between" align="middle">
                <el-link :underline="false" @click="toPage('news')">{{ item.title }}</el-link>
                <div class="news-time">{{ item.createTime }}</div>
              </el-row>
            </div>
          </template>
          <template v-else>
            <div class="noData">暂无数据</div>
          </template>
        </div>
      </div>
      <div class="news-box right">
        <el-row type="flex" justify="space-between" align="middle" class="news-title">
          <h4>平台公告</h4>
          <el-link :underline="false" @click="toPage('notice')">
            更多
            <i class="el-icon-arrow-right"></i>
          </el-link>
        </el-row>
        <div class="news-content">
          <template v-if="Object.keys(listNotice).length">
            <div class="news-item" v-for="item in listNotice" :key="item.id">
              <el-row type="flex" justify="space-between" align="middle">
                <el-link :underline="false" @click="toPage('notice')">{{ item.title }}</el-link>
                <div class="news-time">{{ item.createTime }}</div>
              </el-row>
            </div>
          </template>
          <template v-else>
            <div class="noData">暂无数据</div>
          </template>
        </div>
      </div>
    </el-row>
    <el-dialog
      title="公告详情"
      :visible.sync="dialogDetailVisible"
      width="60%"
      class="detail-container"
      @close="handleClose"
      top="4vh"
    >
      <h3 class="title">{{ arr.title }}</h3>
      <p class="notice-content" v-html="arr.content"></p>
      <el-row v-if="Object.keys(arr).length && arr.accessoryList.length">
        <div>附件：</div>
        <el-col :span="12">
          <div v-for="(item, index) in arr.accessoryList" :key="item.accessoryId">
            <el-row type="flex" align="middle">
              <div>{{ index + 1 + ". " + item.accessoryName }}</div>
              <el-button type="text" @click="downloadFile(item)">下载</el-button>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogDetailVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { ajaxPost, Baseurl } from "@/api/api/api";

export default {
  name: "Home",
  props: {
    roleStatus: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      dialogDetailVisible: false,
      title: '',
      content: '',
      UserInfo: {},
      linkList: [
        {
          title: "美国站",
          imgUrl: require("@/assets/AMZImgs/US.jpg"),
          jumpUrl: "https://www.amazon.com/",
        },
        {
          title: "加拿大站",
          imgUrl: require("@/assets/AMZImgs/CA.jpg"),
          jumpUrl: "https://www.amazon.ca/",
        },
        {
          title: "墨西哥站",
          imgUrl: require("@/assets/AMZImgs/MX.jpg"),
          jumpUrl: "https://www.amazon.com.mx/",
        },
        {
          title: "英国站",
          imgUrl: require("@/assets/AMZImgs/UK.jpg"),
          jumpUrl: "https://www.amazon.co.uk/",
        },
        {
          title: "德国站",
          imgUrl: require("@/assets/AMZImgs/DE.jpg"),
          jumpUrl: "https://www.amazon.de/",
        },
        {
          title: "法国站",
          imgUrl: require("@/assets/AMZImgs/FR.jpg"),
          jumpUrl: "https://www.amazon.fr/",
        },
        {
          title: "意大利站",
          imgUrl: require("@/assets/AMZImgs/IT.jpg"),
          jumpUrl: "https://www.amazon.it/",
        },
        {
          title: "西班牙站",
          imgUrl: require("@/assets/AMZImgs/ES.jpg"),
          jumpUrl: "https://www.amazon.es/",
        },
        {
          title: "荷兰站",
          imgUrl: require("@/assets/AMZImgs/NL.jpg"),
          jumpUrl: "https://www.amazon.nl/",
        },
        {
          title: "日本站",
          imgUrl: require("@/assets/AMZImgs/JP.jpg"),
          jumpUrl: "https://www.amazon.co.jp/",
        },
        {
          title: "澳洲站",
          imgUrl: require("@/assets/AMZImgs/AU.jpg"),
          jumpUrl: "https://www.amazon.com.au/",
        },
        {
          title: "印度站",
          imgUrl: require("@/assets/AMZImgs/IN.jpg"),
          jumpUrl: "https://www.amazon.in/",
        },
        {
          title: "阿联酋站",
          imgUrl: require("@/assets/AMZImgs/AE.jpg"),
          jumpUrl: "https://www.amazon.ae/",
        },
        {
          title: "新加坡站",
          imgUrl: require("@/assets/AMZImgs/SG.jpg"),
          jumpUrl: "https://www.amazon.sg/",
        },
        {
          title: "波兰站",
          imgUrl: require("@/assets/AMZImgs/PL.jpg"),
          jumpUrl: "https://www.amazon.pl/",
        },
        {
          title: "巴西站",
          imgUrl: require("@/assets/AMZImgs/BR.jpg"),
          jumpUrl: "https://www.amazon.com.br/",
        },
        {
          title: "沙特阿拉伯",
          imgUrl: require("@/assets/AMZImgs/SA.jpg"),
          jumpUrl: "https://www.amazon.sa/",
        },
        {
          title: "1688",
          imgUrl: require("@/assets/AMZImgs/1688.jpg"),
          jumpUrl: "https://www.1688.com/",
        },
        // {
        //   title: "谷歌翻译",
        //   imgUrl: require("@/assets/AMZImgs/GOOGLE.jpg"),
        //   jumpUrl: "https://translate.google.cn/",
        // },
        {
          title: "Comfy UI画图工具",
          imgUrl: require("@/assets/AMZImgs/ComfyUI.svg"),
          jumpUrl: "https://8gifttnxrhm6.vip3.xiaomiqiu123.top",
        },
        {
          title: "美国商标局",
          imgUrl: require("@/assets/AMZImgs/USPTO.jpg"),
          jumpUrl:
            "https://tmsearch.uspto.gov/search/search-information",
        },
        // {
        //   title: "Facebook",
        //   imgUrl: require("@/assets/AMZImgs/Facebook.jpg"),
        //   jumpUrl: "https://www.facebook.com/",
        // },
        {
          title: "在线PS",
          imgUrl: require("@/assets/AMZImgs/photoshop.svg"),
          jumpUrl: "https://www.photopea.com/",
        },
        {
          title: "17TRACK",
          imgUrl: require("@/assets/AMZImgs/17TRACK.jpg"),
          jumpUrl: "https://www.17track.net/zh-cn",
        },
        {
          title: "AMZ123",
          imgUrl: require("@/assets/AMZImgs/AMZ123.jpg"),
          jumpUrl: "https://www.amz123.com/",
        },
        {
          title: "518DMJ",
          imgUrl: require("@/assets/AMZImgs/518.jpg"),
          jumpUrl: "http://518dmj.com/",
        },
      ],
      listNews: [],
      listNotice: [],
      arr: {}
    };
  },
  created() {

        this.UserInfo = JSON.parse(localStorage.getItem("role"));
        if(this.UserInfo==null){
            return false;
        }else{
            this.getPlatformNotice();
        }
    // this.$nextTick(()=>{
    //     this.getPlatformNotice();
    // })
    
  },
  mounted(){
  },
  watch: {
    roleStatus: {
      handler(newVal, oldVal) {
        if (newVal && newVal !== oldVal) {
          this.getPlatformNews();
        }
      },
      immediate: true,
    },
  },
  methods: {
    handleClose() {
      const ids = [this.arr.id];
      this.readInfo(ids);
    },
    readInfo(ids) {
      const API = Baseurl + "announcementController/readAnnouncementInfo";
      const paramsData = {
        readRid: this.UserInfo.rid,
        ids,
      };
      ajaxPost(API, paramsData).then((res) => {
        const { code } = res.data;
        if (code === 200) {
          ids.forEach((item) => {
            this.listNotice.find((key) => key.id === item).whetherToRead = 1;
            this.$parent.getUnreadMsgNum()
          });
        }
      });
    },
    downloadFile(item) {
      const AElement = document.createElement("a");
      AElement.target="_blank"
      AElement.href = item.accessoryUrl;
      AElement.download = item.accessoryName;
      AElement.click();
      this.$message.success("正在下载...");
    },
    jumpPage({ jumpUrl }) {
      if (!jumpUrl) return;
      window.open(jumpUrl);
    },
    getPlatformNotice() {
      const API =
        Baseurl + "announcementController/selectAnnouncementInfoReleased";
      const paramsData = {
        page: 1,
        size: 5,
        readRid: this.UserInfo.rid,
      };
      ajaxPost(API, paramsData).then((res) => {
        const {
          data: { code, data },
        } = res;
        if (code === 200) {
          this.listNotice = data.list
          // 只检查最新一条公告，如果是未读就弹出
          const latest = data.list[0]
          if (latest && latest.whetherToRead === 2) {
            this.dialogDetailVisible = true
            this.arr = latest
            this.readInfo([latest.id])
          }
        }
      });
    },
    getPlatformNews() {
      const API = Baseurl + "platformNewsController/selectPlatformNews";
      const paramsData = {
        page: 1,
        size: 5,
        rid: this.roleStatus,
      };
      ajaxPost(API, paramsData).then((res) => {
        const {
          data: { code, data },
        } = res;
        if (code === 200) {
          this.listNews = data.list;
        }
      });
    },
    toPage(type) {
      this.$router.push({ name: "noticeList", params: { pageType: type } });
    },
  },
};
</script>

<style lang="scss" scoped>
.home {
  width: 98%;
  overflow: hidden;
  .link-container {
    display: flex;
    flex-wrap: wrap;
    user-select: none;
    .link-box {
      width: calc(100% / 8);
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 40px;
      .link-item {
        display: flex;
        flex-direction: column;
        align-content: center;
        justify-content: center;
        cursor: pointer;
        &:hover .link-title {
          color: #409eff;
        }
        .el-image{
          margin: 0 auto;
        }
        .link-title {
          margin-top: 10px;
          text-align: center;
        }
      }
    }
  }
  .detail-container {
    .title {
      text-align: center;
      margin-bottom: 10px;
    }
  }
  .news-box {
    width: 49%;
    height: 272px;
    border-radius: 4px;
    margin-bottom: 20px;
    overflow: hidden;
    &.left {
      border: 1px solid #deefd8;
      .news-title {
        background: #deefd8;
      }
      .news-item + .news-item {
        border-top: 1px dashed #deefd8;
      }
    }
    &.right {
      border: 1px solid #7cc7ea;
      .news-title {
        background: #7cc7ea;
      }
      .news-item + .news-item {
        border-top: 1px dashed #7cc7ea;
      }
    }
    .news-title {
      line-height: 40px;
      padding: 0 10px;
      box-sizing: border-box;
    }
    .news-content {
      padding: 10px 20px;
      height: calc(100% - 40px);
      box-sizing: border-box;
      .news-item {
        line-height: 40px;
        .el-link {
          flex: 1;
          min-width: 0;
        }
        /deep/ .el-link--inner {
          width: 100%;
          display: block;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .news-time {
          flex-shrink: 0;
        }
      }
    }
  }
  .noData{
    text-align: center;
    line-height: 80px;
    color:#999;
    user-select: none;
  }
}
</style>
